/** Extract a user-visible message from adminWebTools /ago API responses. */
export function getApiErrorMessage(res) {
    if (!res) return null;

    if (res.detail) {
        if (typeof res.detail === 'string') {
            return res.detail;
        }
        if (typeof res.detail === 'object' && res.detail.message) {
            return res.detail.message;
        }
        return JSON.stringify(res.detail);
    }

    if (res.message && typeof res.message === 'string') {
        if (!Array.isArray(res.paginated_data)) {
            return res.message;
        }
    }

    if (res.status && typeof res.status === 'string' && res.status !== 'success') {
        if (!Array.isArray(res.paginated_data)) {
            return res.status;
        }
    }

    return null;
}

export function isPaginatedApiSuccess(res) {
    return !getApiErrorMessage(res) && Array.isArray(res?.paginated_data);
}

export function formatApiCatchError(e) {
    if (e == null) return 'unknown error';
    if (typeof e === 'string') return e;
    if (e.message) return e.message;
    if (e.response?.data?.detail) {
        const detail = e.response.data.detail;
        return typeof detail === 'string' ? detail : JSON.stringify(detail);
    }
    if (e.response?.data?.message) {
        return e.response.data.message;
    }
    return String(e);
}
